export default "__VITE_ASSET__YfGDn3Vy__"